import { format, parseISO } from 'date-fns'

// Parses various ISO-like inputs and returns dd/MM/yyyy for display
export const formatDisplayDate = (input) => {
  if (!input) return ''
  try {
    // Ensure Z for UTC when missing (e.g., 2025-10-22T00:00:00)
    const normalized = typeof input === 'string' && /T\d{2}:\d{2}:\d{2}$/.test(input)
      ? `${input}Z`
      : input

    const date = typeof normalized === 'string' ? parseISO(normalized) : new Date(normalized)
    if (Number.isNaN(date.getTime())) return ''
    return format(date, 'dd/MM/yyyy')
  } catch {
    return ''
  }
}

// Returns YYYY-MM-DD (useful for <input type="date"> values)
export const formatDateYYYYMMDD = (date) => {
  const d = date instanceof Date ? date : new Date(date)
  if (Number.isNaN(d.getTime())) return ''
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}
